import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import OnboardingTransferContacts from "@/components/onboarding/OnboardingTransferContacts/OnboardingTransferContacts.vue";
import { OnboardingContainerTypeEnum } from "@/types/onboarding";
import { onboardingInjectionKey } from "@/utils/onboarding/onboardingInjectionKey";
import { provide } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsTransferContacts',
  setup(__props) {

provide(onboardingInjectionKey, {
  type: OnboardingContainerTypeEnum.Settings,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(OnboardingTransferContacts))
}
}

})